export const findSurveyResponse = (
  Q1: {
    title: string;
    type: string;
    choices?: { value: unknown; text: string }[];
    rateValues?: { value: unknown; text: string }[];
    inputType?: string;
    rateType?: string;
  }[],
  A1: { [key: string]: any }
) => {
  const obj: { [key: string]: any } = {};
  const tagboxItem: string[] = [];

  Object.entries(A1).forEach(([key, value]) => {
    const filteredData = Q1.find((el) => el.title === key);
    if (filteredData) {
      switch (filteredData.type) {
        case 'radiogroup':
        case 'dropdown':
          obj[key] = {
            answer: filteredData.choices?.find((choice) => choice.value === value)?.text,
            type: filteredData?.type,
            subType: '',
          };
          break;
        case 'file':
          obj[key] = { answer: `${value[0].content}`, type: filteredData?.type, subType: '' };
          break;
        case 'boolean':
        case 'text':
        case 'comment':
        case 'signaturepad':
          obj[key] = {
            answer: `${value}`,
            type: filteredData?.type,
            subType: filteredData?.inputType ? filteredData?.inputType : '',
          };
          break;
        case 'rating':
          obj[key] = {
            answer: filteredData.rateValues?.find((rateValue) => rateValue.value === value)?.text,
            type: filteredData?.type,
            subType: filteredData?.rateType ? filteredData?.rateType : '',
          };
          break;
        case 'checkbox':
        case 'tagbox':
          value.forEach((v1: any) => {
            const foundChoice = filteredData.choices?.find((choice) => choice.value === v1);
            if (foundChoice) {
              tagboxItem.push(foundChoice.text);
            }
          });

          obj[key] = { answer: tagboxItem.join(', '), type: filteredData?.type, subType: '' };
          break;
        default:
          break;
      }
    }
  });

  return obj;
};
